<template>
	<div class="wrap">
		<div class="main">
			<div class="neibox">
				<div class="shaibox">
					<el-form size="small" inline>
						<el-form-item >
							<el-input  style="width: 200px;margin-right: 15px;" v-model="input" placeholder="项目名称"></el-input>
						</el-form-item>
						<el-form-item >
							<el-select v-model="taivalue" @change="qieStatus" placeholder="状态" style="margin-right: 15px;">
								<el-option v-for="item in zhaungtaiList" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item >
							<el-select @change="qieleixing" v-model="value" placeholder="类型" style="margin-right: 15px;">
								<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.label">
								</el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item >
							<el-select @change="qieQian" v-model="feivalue" placeholder="是否欠费" style="margin-right: 15px;">
								<el-option v-for="item in qianfeiList" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item >
							<el-button type="primary" @click="getWeiList">搜索</el-button>
						</el-form-item>
						
						
						
						
					</el-form>
				
				</div>
				<el-tabs v-model="activeName" type="card" @tab-click="handleClick">
					<el-tab-pane label="全部" name="first">
						<el-table :data="tableData" style="width: 100%">
							<el-table-column prop="title" label="项目名称" width="150">
							</el-table-column>
							<el-table-column prop="type" label="项目类型" width="120">
							</el-table-column>
							<!-- <el-table-column label="合同" width="100">
								<template slot-scope="scope">
									<el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/"
										:on-preview="handlePreview" :on-remove="handleRemove"
										:before-remove="beforeRemove" multiple :limit="3" :on-exceed="handleExceed"
										:file-list="fileList">
										<el-button size="small" type="primary">上传</el-button>

									</el-upload>
								</template>
							</el-table-column> -->
							<el-table-column prop="admin.real_name" label="所属会员/客服">
							</el-table-column>
							<el-table-column prop="create_time" label="开通日期" >
							</el-table-column>
							<el-table-column prop="end_time" label="到期日期" >
							</el-table-column>
							<el-table-column prop="money" label="项目金额/欠额" >
							</el-table-column>
							<el-table-column prop="status" label="项目状态" >
								<template slot-scope="scope">
									<div class="taibox" v-if="scope.row.status == 0">未完成</div>
									<div class="taibox" v-if="scope.row.status == 1">已完成</div>
									<div class="taibox" v-if="scope.row.status == 2">已结清</div>
									<div class="taibox" v-if="scope.row.status == 3">已交付</div>
									<div class="taibox" v-if="scope.row.status == 4">转维护</div>
									<div class="taibox" v-if="scope.row.status == 5">维护中</div>
									<div class="taibox" v-if="scope.row.status == 200">不续费</div>
								</template>
							</el-table-column>

							<el-table-column prop="repay_money" label="续费价格" width="150">
							</el-table-column>
							<el-table-column label="操作" width="200">
								<template slot-scope="scope">
									<el-button size="mini" type="success"
										@click="handleDelete(scope.$index, scope.row.id)">详情</el-button>
									<el-button size="mini" type="warning"
										@click="xufei(scope.$index, scope.row.id)">续费</el-button>
								</template>
							</el-table-column>
						</el-table>
						<div class="fenye">
							<FenPage :total="page_data.total"  :page.sync="page_data.page" :limit.sync="page_data.limit" @pagination="getWeiList" />
						</div>
					</el-tab-pane>
					<el-tab-pane label="已过期" name="second">
						<el-table :data="tableData" style="width: 100%">
							<el-table-column prop="title" label="项目名称" width="150">
							</el-table-column>
							<el-table-column prop="type" label="项目类型" width="120">
							</el-table-column>
							<!-- <el-table-column label="合同" width="100">
								<template slot-scope="scope">
									<el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/"
										:on-preview="handlePreview" :on-remove="handleRemove"
										:before-remove="beforeRemove" multiple :limit="3" :on-exceed="handleExceed"
										:file-list="fileList">
										<el-button size="small" type="primary">上传</el-button>
						
									</el-upload>
								</template>
							</el-table-column> -->
							<el-table-column prop="admin.real_name" label="所属会员/客服">
							</el-table-column>
							<el-table-column prop="create_time" label="开通日期" >
							</el-table-column>
							<el-table-column prop="end_time" label="到期日期" >
							</el-table-column>
							<el-table-column prop="money" label="项目金额/欠额" >
							</el-table-column>
							<el-table-column prop="status" label="项目状态" >
								<template slot-scope="scope">
									<div class="taibox" v-if="scope.row.status == 0">未完成</div>
									<div class="taibox" v-if="scope.row.status == 1">已完成</div>
									<div class="taibox" v-if="scope.row.status == 2">已结清</div>
									<div class="taibox" v-if="scope.row.status == 3">已交付</div>
									<div class="taibox" v-if="scope.row.status == 4">转维护</div>
									<div class="taibox" v-if="scope.row.status == 5">维护中</div>
									<div class="taibox" v-if="scope.row.status == 200">不续费</div>
								</template>
							</el-table-column>
						
							<el-table-column prop="repay_money" label="续费价格" width="150">
							</el-table-column>
							<el-table-column label="操作" width="200">
								<template slot-scope="scope">
									<el-button size="mini" type="success"
										@click="handleDelete(scope.$index, scope.row.id)">详情</el-button>
									<el-button size="mini" type="warning"
										@click="xufei(scope.$index, scope.row.id)">续费</el-button>
								</template>
							</el-table-column>
						</el-table>
						<div class="fenye">
							<FenPage :total="page_data.total"  :page.sync="page_data.page" :limit.sync="page_data.limit" @pagination="getWeiList" />
						</div>
					</el-tab-pane>
				</el-tabs>


			</div>
			<!-- 弹框详情 -->
			<el-dialog title="详情" top="7vh" :visible.sync="dialogVisible" width="60%" :before-close="handleClose">
				<div class="xubox">
					<div class="kebox">
						<div class="ketxt">
							项目名称
							<span>{{weiInfo.title}}</span>
						</div>
					</div>

					<div class="kebox">
						<div class="ketxt">
							项目金额
							<span>{{weiInfo.money}}</span>
						</div>
					</div>

					<div class="kebox">
						<div class="ketxt">
							项目备注
						</div>
						<el-input disabled type="textarea" :rows="4" placeholder="请输入内容" v-model="weiInfo.auth">
						</el-input>
					</div>

					<div class="kebox">
						<div class="timetxt">
							开通日期
							<span>{{weiInfo.create_time}}</span>
						</div>
						<div class="timetxt">
							结束日期
							<span>{{weiInfo.end_time}}</span>
						</div>
					</div>

					<div class="kebox">
						<div class="timetxt">
							已收金额
							<span>{{weiInfo.shou_money}}</span>
						</div>
						<div class="timetxt">
							欠款金额
							<span>{{weiInfo.qian_money}}</span>
						</div>
					</div>
				</div>

				<div class="xubox">
					<div class="xqtitle">
						收款信息
					</div>

					<el-table :data="weiInfo.item" border style="width: 100%">
						<el-table-column prop="money" label="收款金额">
						</el-table-column>
						<el-table-column prop="create_time" label="收款日期">
						</el-table-column>

						<el-table-column prop="body" label="收款备注">
						</el-table-column>
						<!-- <el-table-column label="操作">
							<template slot-scope="scope">
								<el-button size="mini" v-if="scope.row.jine>10000" type="primary">详情</el-button>
							</template>
						</el-table-column> -->
					</el-table>
				</div>
			</el-dialog>

			<!-- 弹框续费 -->
			<el-dialog title="续费" :visible.sync="xufeiMask" width="1100px" :before-close="xufeiClose">
				<div class="xubox">
					<div class="mingbox">
						<div class="mingtitle">项目名称</div>
						<input type="text" class="mingput" disabled v-model="info.title">
					</div>
					<div class="mingbox">
						<div class="mingtitle">到期日期</div>
						<input type="text" class="mingput" disabled v-model="info.end_time">
					</div>
					<div class="mingbox">
						<div class="mingtitle">续费金额</div>
						<input type="text" class="mingput" disabled v-model="info.repay_money">
					</div>
					<div class="mingbox">
						<div class="mingtitle">续费金额</div>
						<el-select @change="getMoney" style="flex-grow: 1;" v-model="jineValue" placeholder="请选择">
							<el-option v-for="(item,index) in info.option" :key="index" :label="item"
								:value="index">
							</el-option>
						</el-select>
					</div>

				</div>

				<span slot="footer" class="dialog-footer">
					<el-button type="primary" @click="xufeiMask = false">确认</el-button>
					<el-button @click="xufeiMask = false">返回</el-button>
				</span>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import FenPage from '../../components/FenPage.vue'
	export default {
		components:{
			FenPage
		},
		data() {
			return {
				// 全部/已过期
				activeName: 'first',
				// 搜索
				input: '',
				// 全部 已过期
				isend: 0,
				// 类型
				options: [
					{
						value: '1',
						label: '类型'
					},{
					value: '2',
					label: '维护'
				}, {
					value: '3',
					label: '定制维护'
				}, {
					value: '4',
					label: '模板维护'
				}],
				value: '',
				type:'',
				// 状态
				zhaungtaiList: [{
					value: '0',
					label: '状态'
				},{
					value: '1',
					label: '未处理'
				}, {
					value: '2',
					label: '已结清'
				}, {
					value: '3',
					label: '已交付'
				}],
				taivalue: '',
				status:'',
				// 是否欠费
				qianfeiList: [{
					value: '0',
					label: '是否欠费'
				}, {
					value: '1',
					label: '是'
				}],
				feivalue: '',
				isqian:0,
				// 上传
				fileList: [],
				// 表格全部
				tableData: [],
				// 表格全部分页
				page_data: {
					limit: 15,
					page: 1,
					total:20,
				},
				// 过期
				guoqiData: [],
				// 分页
				currentPage2: 5,
				currentPage: 1,

				// 弹框详情
				weiInfo:{},
				dialogVisible: false,
				textarea: '',
				showData: [],
				// 弹框续费
				xufeiMask: false,
				info: {
					option:{}
				},
				xufeiId:'',
				xufeiTime:'',
				jineValue:''
			}
		},
		created() {
			this.getWeiList()
		},
		methods: {
			// 请求全部列表
			async getWeiList() {
				this.tableData = []
				let param = {limit:this.page_data.limit,page:this.page_data.page}
				Object.assign(param, {
					status: this.status,
					title : this.input,
					type:this.type,
					is_qian:this.isqian,
					is_end:this.isend
				})
				const res = await this.$api.getWeiList(param);
				this.tableData = res.data.data
				this.page_data.total = res.data.total
			},
			
			// 状态
			qieStatus(e){
				console.log(e)
				if(e == 0){
					this.status = ''
				}else if(e == 1){
					this.status = 0
				}else if(e == 2){
					this.status = 1
				}else if(e == 3){
					this.status = 2
				}
				console.log(this.status)
			},
			// 类型
			qieleixing(e){
				console.log(e)
				this.type = e
			},
			// 是否欠费
			qieQian(e){
				this.isqian = e
			},
			
			
			
			
			// 全部/已过期
			handleClick(tab, event) {
				if(tab.index == 0){
					this.isend = 0
					this.getWeiList()
				}else{
					this.isend = 1
					this.getWeiList(1)
				}
			},

			// 弹框详情
			handleClose(done) {
				this.dialogVisible = false
			},
			handleDelete(index, row) {
				console.log(index, row);
				this.dialogVisible = true
				this.getWeiInfo(row)
			},
			async getWeiInfo(id) {
				const res = await this.$api.getWeiInfo({id:id});
				this.weiInfo = res.data
			},
			// 弹框续费
			xufei(index, row) {
				this.xufeiMask = true
				this.xufeiId = row
				this.getWeiRepay(row)
			},
			// 续费详情
			async getWeiRepay(id) {
				const res = await this.$api.getWeiRepay({id:id});
				this.info = res.data
			},
			// 续费时长
			getMoney(e){
				console.log(e)
				this.xufeiTime = e
			},
			// 续费
			async getWeiDoRepay() {
				const res = await this.$api.getWeiDoRepay({
					id:this.xufeiId,
					time_id:this.xufeiTime
				});
				alert('续费成功')
				this.xufeiMask = false
			},
			
			
			xufeiClose() {
				this.xufeiMask = false
			},


			// 上传图片
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handlePreview(file) {
				console.log(file);
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			}
		},

	}
</script>

<style>
	.neibox {
		padding: 20px;
		background-color: #ffffff;
		border-radius: 5px;
	}

	.shaibox {
		display: flex;
		align-items: center;
		padding-bottom: 25px;
	}

	.taibox {
		width: 50px;
		height: 20px;
		background-color: #1E9FFF;
		text-align: center;
		line-height: 20px;
		font-size: 12px;
		color: #ffffff;
		border-radius: 5px;
	}

	.fenye {
		display: flex;
		align-items: center;
		justify-content: center;
		padding-top: 20px;
	}

	.el-dialog__header {
		background-color: #f8f8f8 !important;
	}

	.el-dialog__body {
		background-color: #f2f2f2 !important;
	}

	.el-dialog__footer {
		background-color: #f2f2f2 !important;
	}

	.xubox {
		background-color: #ffffff;
		padding: 15px;
		margin-bottom: 15px;
	}

	.kebox {
		display: flex;
		align-items: flex-start;
		padding-bottom: 30px;
	}

	.ketxt {
		font-size: 14px;
		color: #333333;
		flex-shrink: 0;
		padding-right: 15px;
	}

	.ketxt span {
		color: #999999;
		padding-left: 10px;
		font-size: 14px;
	}

	.el-dialog__footer {
		text-align: left;
	}

	.timetxt {
		font-size: 14px;
		color: #333333;
		flex-shrink: 0;
		width: 35%;
	}

	.timetxt span {
		color: #999999;
		padding-left: 10px;
		font-size: 14px;
	}

	.xqtitle {
		font-size: 14px;
		color: #333333;
		border-bottom: 1px solid #ddd;
		padding: 0 0 20px;
		margin-bottom: 15px;
	}

	.mingbox {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 20px 15px;
	}

	.mingtitle {
		font-size: 14px;
		color: #666666;
		padding-right: 15px;
		flex-shrink: 0;
	}

	.mingput {
		border: 1px solid #dddddd;
		font-size: 14px;
		color: #333333;
		flex-grow: 1;
		padding: 12px 15px;
		border-radius: 3px;
	}
</style>